



























































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';

import {
    FindFiltersParams,
    Promotions,
    Sales,
    SelectBox,
    SkuRotationPeriodType,
} from '@/interfaces/global-data';
import {
    CompetitorsPriceMethods, CompetitorsPriceStrategies,
    competitorsPromoPriceMethodsSb,
    competitorsPromoPriceStrategiesSb,
    GetTaskInfo,
    PercentileTypes,
    ProductInfoResponseProperty,
    PromoFilterProducts,
    PromoFilterType,
    TaskInfoFilterType,
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import Toast from '@/mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import {
    TModuleType,
    EntityMaskOptions,
    TaskTypeEntityProperties,
    CategoryFiltersValues,
    EntityFilterKeys,
    CategoryParamsValues,
    CategoryFindFiltersPayload,
} from "@/pages/ModuleItems/data";
import SwitchWithLabel from "@/components/UI/SwitchWithLabel.vue";

@Component({
    computed: {
        moment() {
            return moment;
        },
        PromoFilterType() {
            return PromoFilterType;
        },
        PromoFilterProducts() {
            return PromoFilterProducts;
        },
        TaskInfoFilterType() {
            return TaskInfoFilterType;
        }
    },
    methods: {
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
    },
    components: {
        SwitchWithLabel,
        ResultView,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        HintsContainer,
        DatePicker,
        CollapseCard,
        Card,
    },
})
export default class CategoryParameters extends Mixins(Toast, Http, LocalData) {
    @Prop() readonly moduleType!: TModuleType;
    @Prop({required: false}) readonly initFilterValues: CategoryFiltersValues = {} as CategoryFiltersValues;

    @Watch('initFilterValues', {deep: true})
    onInitFilterValuesChanged() {
        this.categoryFilters.groupId = this.initFilterValues.groupId || 0;
        this.categoryFilters.categoryId = this.initFilterValues.categoryId || 0;
        this.categoryFilters.subcategoryId = this.initFilterValues.subcategoryId || 0;
        this.categoryFilters.formatId = this.initFilterValues.formatId || 0;
        this.categoryFilters.regionId = this.initFilterValues.regionId || 0;
        this.categoryFilters.clusterId = this.initFilterValues.clusterId || 0;

        this.fetchEntityMaskSelectOptions(TaskInfoFilterType.group, 'entityGroupSelectRef');
        this.fetchEntityMaskSelectOptions(TaskInfoFilterType.category, 'entityCategorySelectRef');
        this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
        this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
        this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionSelectRef');
        this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClusterSelectRef');

        if (this.isGroupSelected) {
            this.fetchModuleCategoryParams();
        } else {
            this.setDefaultValuesForCategoryParams();
        }
    }

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions;
        } else {
            return this.$sales;
        }
    }

    set moduleData(data: Sales | Promotions) {
        if (this.moduleType === 'promo') {
            this.$promotions = data as Promotions;
        } else {
            this.$sales = data as Sales;
        }
    }

    get saveModuleItems() {
        if (this.moduleType === 'promo') {
            return this.savePromotions;
        } else {
            return this.saveSales;
        }
    }

    get competitorPriceControlParameterPcPromoValidate(): boolean {
        return this.categoryParams.competitorPriceControlParameterPcPromo.toString() !== ''
            && this.categoryParams.competitorPriceControlParameterPcPromo > 0
            && this.categoryParams.competitorPriceControlParameterPcPromo <= 100;
    }

    get competitorsMinProfitPromoValidate(): boolean {
        const competitorsMinimumProfitPromo = this.categoryParams.competitorsMinimumProfitPromo;

        return competitorsMinimumProfitPromo.toString() !== '' && competitorsMinimumProfitPromo >= -50 && competitorsMinimumProfitPromo <= 500;
    }

    competitorsMaximumProfitPromoErrorText = '';

    get competitorsMaximumProfitPromoValidate(): boolean {
        const competitorsMaximumProfitPromo = this.categoryParams.competitorsMaximumProfitPromo != null ? this.categoryParams.competitorsMaximumProfitPromo : 100;
        const competitorsMinimumProfitPromo = this.categoryParams.competitorsMinimumProfitPromo != null ? this.categoryParams.competitorsMinimumProfitPromo : 0;
        if (competitorsMaximumProfitPromo < competitorsMinimumProfitPromo) {
            this.competitorsMaximumProfitPromoErrorText = this.$t('shared.parametersTab.maxProfitMustBeGteMin') as string
        } else if (competitorsMaximumProfitPromo > 100) {
            this.competitorsMaximumProfitPromoErrorText = this.$t('shared.parametersTab.maxProfitMustBeLte100') as string
        } else {
            this.competitorsMaximumProfitPromoErrorText = ''
        }
        return competitorsMaximumProfitPromo >= competitorsMinimumProfitPromo && competitorsMaximumProfitPromo <= 100;
    }

    categoryFilters: CategoryFiltersValues = {
        groupId: null,
        categoryId: null,
        subcategoryId: null,
        formatId: null,
        regionId: null,
        clusterId: null,
    };

    categoryFiltersOptions: EntityMaskOptions = {
        groups: [],
        categories: [],
        subcategories: [],
        formats: [],
        regions: [],
        clusters: [],
    };

    filtersOptionPropertyNames: TaskTypeEntityProperties = {
        group: 'groups',
        category: 'categories',
        subcategory: 'subcategories',
        format: 'formats',
        region: 'regions',
        cluster: 'clusters',
    }

    categoryFiltersPropertyNames: TaskTypeEntityProperties = {
        group: 'groupId',
        category: 'categoryId',
        subcategory: 'subcategoryId',
        format: 'formatId',
        region: 'regionId',
        cluster: 'clusterId',
    }

    defaultCategoryParams: CategoryParamsValues = {
        useProductRange: false,
        usePromoQuote: false,
        promoQuote: null,
        useSkuRotation: false,
        rotationPeriodType: SkuRotationPeriodType.MONTH,
        useCompetitorsPromoPrices: false,
        calculateCompAllowedDeviationPromo: true,
        competitorPriceControlParameterPcPromo: 50,
        competitorsPricePeriod: 28,
        competitorsPromoPriceInfluencesCoef: 1,
        percentileTypePromo: PercentileTypes.Q5,
        competitorsPromoPriceAdjustment: '10',
        competitorsControlPromoParam: 10,
        competitorsPromoPriceMethod: competitorsPromoPriceMethodsSb.MIN_PRICE,
        competitorsMinimumProfitPromo: 0,
        competitorsMaximumProfitPromo: 100,
        competitorsPromoPriceStrategy: competitorsPromoPriceStrategiesSb.EQUALS,
    }

    competitorsPromoPriceMethodsOptions = [
        {value: CompetitorsPriceMethods.MIN_PRICE, label: this.$t('shared.categoryParams.minPromoPrice') as string},
        {value: CompetitorsPriceMethods.AVG_PRICE, label: this.$t('shared.categoryParams.avgPromoPrice') as string},
        {value: CompetitorsPriceMethods.MAX_PRICE, label: this.$t('shared.categoryParams.maxPromoPrice') as string},
        {value: CompetitorsPriceMethods.WESTENDORP, label: 'Westendorp'},
        {value: CompetitorsPriceMethods.MEDIAN_PRICES, label: this.$t('shared.categoryParams.medianPromoPrice') as string},
    ]

    competitorsPromoPriceStrategiesOptions = [
        {value: CompetitorsPriceStrategies.EQUALS, label: this.$t('shared.categoryParams.priceEqualsCompetitor') as string},
        {value: CompetitorsPriceStrategies.GREATER_THAN, label: this.$t('shared.categoryParams.priceGreaterCompetitor') as string},
        {value: CompetitorsPriceStrategies.GREATER_THAN_BUT_BORDER, label: this.$t('shared.categoryParams.priceGreaterButBorder') as string},
        {value: CompetitorsPriceStrategies.LESS_THAN, label: this.$t('shared.categoryParams.priceLessCompetitor') as string},
    ]

    categoryParams: CategoryParamsValues = {
        ...this.defaultCategoryParams,
    };

    isCategoryParamsLoading = false;
    isSaveBtnLoading = false;

    fetchModuleCategoryParams(isByButtonClick: boolean = false) {
        this.isCategoryParamsLoading = true;

        const findParams = new FindFiltersParams();

        findParams.tradingId = this.moduleData.selectMarket.id;
        findParams.groupOfProduct = this.categoryFilters.groupId || null;
        findParams.category = this.categoryFilters.categoryId || null;
        findParams.subcategories = this.categoryFilters.subcategoryId ? [this.categoryFilters.subcategoryId] : [];
        findParams.storeFormat = this.categoryFilters.formatId || null;
        findParams.storeRegionValues = this.categoryFilters.regionId ? [this.categoryFilters.regionId] : [];
        findParams.storeCluster = this.categoryFilters.clusterId || null;

        this.httpFindPromotionsCategoryParams(findParams)
            .then((resp) => {
                if (resp.status === 200) {
                    this.categoryParams = ((
                        {
                            promoQuote,
                            useProductRange,
                            useSkuRotation,
                            rotationPeriodType,
                            useCompetitorsPromoPrices,
                            calculateCompAllowedDeviationPromo,
                            competitorPriceControlParameterPcPromo,
                            competitorsPricePeriod,
                            competitorsPromoPriceInfluencesCoef,
                            percentileTypePromo,
                            competitorsPromoPriceAdjustment,
                            competitorsControlPromoParam,
                            competitorsPromoPriceMethod,
                            competitorsMinimumProfitPromo,
                            competitorsMaximumProfitPromo,
                            competitorsPromoPriceStrategy,
                        }) => {
                        return {
                            usePromoQuote: !!promoQuote,
                            promoQuote,
                            useProductRange,
                            useSkuRotation,
                            rotationPeriodType,
                            useCompetitorsPromoPrices,
                            calculateCompAllowedDeviationPromo,
                            competitorPriceControlParameterPcPromo,
                            competitorsPricePeriod,
                            competitorsPromoPriceInfluencesCoef,
                            percentileTypePromo,
                            competitorsPromoPriceAdjustment,
                            competitorsControlPromoParam,
                            competitorsMinimumProfitPromo,
                            competitorsMaximumProfitPromo: competitorsMaximumProfitPromo != null ? competitorsMaximumProfitPromo : 100,
                            competitorsPromoPriceMethod: this.competitorsPromoPriceMethodsOptions.find((e) => {
                                return e.value === competitorsPromoPriceMethod;
                            }) as SelectBox<CompetitorsPriceMethods>,
                            competitorsPromoPriceStrategy: this.competitorsPromoPriceStrategiesOptions.find((e) => {
                                return e.value === competitorsPromoPriceStrategy
                            }) as SelectBox<CompetitorsPriceStrategies>,
                        };
                    })(resp.data.filters);

                    this.showInfo(this.$t('shared.categoryParams.categoryParamsLoaded') as string);
                } else if (resp.status === 204) {
                    this.setDefaultValuesForCategoryParams();

                    if (isByButtonClick) {
                        this.showInfo(this.$t('shared.categoryParams.categoryParamsNotSaved') as string, 4);
                    }
                }
            })
            .catch(() => {
                this.setDefaultValuesForCategoryParams();

                this.showError(this.$t('shared.categoryParams.errorLoadCategoryParams') as string);
            })
            .finally(() => {
                this.isCategoryParamsLoading = false;
            });
    }

    saveCategoryParams() {
        this.isSaveBtnLoading = true;

        const payload: CategoryFindFiltersPayload = {
            ...(new FindFiltersParams()),
            tradingId: this.moduleData.selectMarket.id,
            groupOfProduct: this.categoryFilters.groupId || null,
            category: this.categoryFilters.categoryId || null,
            subcategories: this.categoryFilters.subcategoryId ? [this.categoryFilters.subcategoryId] : [],
            storeFormat: this.categoryFilters.formatId || null,
            storeRegionValues: this.categoryFilters.regionId ? [this.categoryFilters.regionId] : [],
            storeCluster: this.categoryFilters.clusterId || null,
            productSegments: [],
            seasonValues: [],
        }

        this.httpSavePromotionsCategoryParams({
            ...payload,
            ...this.categoryParams,
            competitorsPromoPriceMethod: this.categoryParams.competitorsPromoPriceMethod.value,
            competitorsPromoPriceStrategy: this.categoryParams.competitorsPromoPriceStrategy.value,
        } as CategoryFindFiltersPayload & CategoryParamsValues & {
            competitorsPromoPriceMethod: CompetitorsPriceMethods;
            competitorsPromoPriceStrategy: CompetitorsPriceStrategies;
        })
            .then(() => {
                this.showInfo(this.$t('shared.categoryParams.categoryParamsSaved') as string);
            })
            .catch(() => {
                this.showError(this.$t('shared.categoryParams.errorSaveCategoryParams') as string);
            })
            .finally(() => {
                this.isSaveBtnLoading = false;
            });
    }

    private get isGroupSelected(): boolean {
        return !!this.categoryFilters.groupId;
    }

    private get isCategorySelected(): boolean {
        return !!this.categoryFilters.categoryId;
    }

    private get isFormatSelected(): boolean {
        return !!this.categoryFilters.formatId;
    }

    private get isRegionSelected(): boolean {
        return !!this.categoryFilters.regionId;
    }

    private getTaskInfo(taskType: EntityFilterKeys): GetTaskInfo {
        return {
            type: taskType,
            tradingId: this.moduleData.selectMarket.id,
            groups: this.categoryFilters.groupId && this.categoryFilters.groupId !== 0 ? [this.categoryFilters.groupId] : null,
            categories: this.categoryFilters.categoryId && this.categoryFilters.categoryId !== 0 ? [this.categoryFilters.categoryId] : null,
            subcategory: this.categoryFilters.subcategoryId && this.categoryFilters.subcategoryId !== 0 ? [this.categoryFilters.subcategoryId] : null,
            storeFormat: this.categoryFilters.formatId && this.categoryFilters.formatId !== 0 ? [this.categoryFilters.formatId] : null,
            storeRegion: this.categoryFilters.regionId && this.categoryFilters.regionId !== 0 ? [this.categoryFilters.regionId] : null,
            storeCluster: this.categoryFilters.clusterId && this.categoryFilters.clusterId !== 0 ? [this.categoryFilters.clusterId] : null,
            productSegments: null,
            segments: null,
            byReports: false,
        }
    }

    fetchEntityMaskSelectOptions(type: EntityFilterKeys, refValue: string) {
        this.$nextTick(() => {
            if (this.$refs[refValue]) {
                (this.$refs[refValue] as any).toggleLoading(true);
            }
        });

        this.httpGetProductInfo(this.getTaskInfo(type))
            .then(data => {
                const options = data.data ? data.data[ProductInfoResponseProperty[type]] : [];

                if (options.length) {
                    this.categoryFiltersOptions[this.filtersOptionPropertyNames[type] as keyof EntityMaskOptions] = [
                        {value: 0, label: this.$t('shared.selectBox.all') as string},
                        ...options.map((i) => {
                            return {value: i.id, label: i.name};
                        }),
                    ];
                } else {
                    this.categoryFiltersOptions[this.filtersOptionPropertyNames[type] as keyof EntityMaskOptions] = [{
                        value: 0,
                        label: this.$t('shared.selectBox.all') as string
                    }];
                }
            })
            .catch(() => {
                this.categoryFiltersOptions[this.filtersOptionPropertyNames[type] as keyof EntityMaskOptions] = [{
                    value: 0,
                    label: this.$t('shared.selectBox.all') as string
                }];

                this.showError(this.$t('shared.parametersTab.errorLoadSelectOptions') as string);
            }).finally(() => {
            if (this.$refs[refValue]) {
                (this.$refs[refValue] as any).toggleLoading(false);
            }
        });
    }

    updateEntityFiltersData(type: EntityFilterKeys) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.category, 'entityCategorySelectRef');
                this.categoryFilters.categoryId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
                this.categoryFilters.subcategoryId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.categoryFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionSelectRef');
                this.categoryFilters.regionId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClusterSelectRef');
                this.categoryFilters.clusterId = 0;

                break;
            case TaskInfoFilterType.category:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.subcategory, 'entitySubcategorySelectRef');
                this.categoryFilters.subcategoryId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.categoryFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionSelectRef');
                this.categoryFilters.regionId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClusterSelectRef');
                this.categoryFilters.clusterId = 0;

                break;
            case TaskInfoFilterType.subcategory:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.format, 'entityFormatSelectRef');
                this.categoryFilters.formatId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionSelectRef');
                this.categoryFilters.regionId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClusterSelectRef');
                this.categoryFilters.clusterId = 0;

                break;
            case TaskInfoFilterType.format:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.region, 'entityRegionSelectRef');
                this.categoryFilters.regionId = 0;

                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClusterSelectRef');
                this.categoryFilters.clusterId = 0;

                break;
            case TaskInfoFilterType.region:
                this.fetchEntityMaskSelectOptions(TaskInfoFilterType.cluster, 'entityClusterSelectRef');
                this.categoryFilters.clusterId = 0;

                break;
        }
    }

    handleEntityFilterChanged(value: number, type: EntityFilterKeys) {
        if (value !== this.categoryFilters[this.categoryFiltersPropertyNames[type] as keyof CategoryFiltersValues]) {
            this.categoryFilters[this.categoryFiltersPropertyNames[type] as keyof CategoryFiltersValues] = value;

            this.updateEntityFiltersData(type);

            if (this.isGroupSelected) {
                this.fetchModuleCategoryParams();
            } else {
                this.setDefaultValuesForCategoryParams();
            }
        }
    }

    setDefaultValuesForCategoryParams() {
        this.categoryParams = {
            ...this.defaultCategoryParams,
        };
    }

    updatePromoQuoteValue() {
        if (!this.categoryParams.usePromoQuote) {
            this.categoryParams.promoQuote = null;
        }
    }

    get promoQuoteValidate(): boolean {
        const promoQuoteValue = this.categoryParams.promoQuote;

        return promoQuoteValue != null && promoQuoteValue > 0;
    }
}
